import "./FooterStyles.css"

import React from 'react';

import { FaHome, FaPhone, FaMailBulk, FaFacebook, FaTwitter, FaLinkedin, FaGithub } from "react-icons/fa";


const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-container">
                <div className="left">
                    <div className="location">
                        <FaHome size={20} style={{ color: "#fff", marginRight: "2rem" }} />
                        <div>
                            <p>Sagar DeenDayal Nagar.</p>
                            <p>Madhya Pradesh.</p>
                        </div>
                    </div>
                    <div className="phone">
                        <h4><FaPhone size={20} style={{ color: "#fff", marginRight: "2rem" }} />
                            9752726642</h4>

                    </div>
                    <div className="email">
                        <h4><FaMailBulk size={20} style={{ color: "#fff", marginRight: "2rem" }} />
                            rukmani0698@gmail.com</h4>
                    </div>
                </div>


                <div className="right">
                    <h4>About Myself</h4>
                    <p>This is me Rukmani Ahirwar. I am 2020 passout student<br />
                         I am a
                        trainee at FunctionUp(pay after placement institute)<br />
                        Looking Forward

                        an opportunity to work with an organisation <br />
                        where I can showcase my skills
                        and can contribute to the company
                    </p>
                    <div className="social">
                  <FaFacebook size={30}
                   style={{ color: "#fff", marginRight: "1rem" }} />
                    <FaTwitter size={30} style={{ color: "#fff", marginRight: "1rem"}} />
                    <FaLinkedin size={30} style={{ color: "#fff", marginRight: "1rem"}} />
<FaGithub size= {30} style={{ color: "#fff", marginRight: "1rem"}} />

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer